<template>
  <base-entity-card
    :id="id"
    titleName="HTML-блока"
    :saveFunc="save"
    :loading="loading"
    @closed="restoreEntity"
    :oneColumn="false"
  >
    <v-form ref="form" v-model="isValid">
     
      <v-text-field
        label="Название *"
        v-model="entity.name"
        :rules="[v => !!v || 'Введите название блока.']"
        filled
      ></v-text-field>
      <v-text-field
        label="Тэг *"
        v-model="entity.tag"
        :rules="[v => !!v || 'Введите тэг.']"
        filled
        append-icon="mdi-autorenew"
        @click:append="generateTag()"
      ></v-text-field>
      
      <v-md-editor v-model="entity.html" height="400px"></v-md-editor>

    </v-form>
  </base-entity-card>
</template>

<script>
import SiteEntityMixin from '../../../models/SiteEntityMixin';
import { transliterate as tr, slugify } from 'transliteration';


export default {
  name: 'site-html-card',

  mixins: [SiteEntityMixin],

  data() {
    return {
      tag: 'html',
    }
  },

  methods: {
    getDefaultEntity() {
      return {
        site: null,
        name: '',
        tag: '',
        html: ''
      }
    },
    generateTag() {
      this.entity.tag = slugify(this.entity.name);
    },
  },
}
</script>